const AMOUNT_INPUT_ONINPUT =
    "value=value.replace(/[^\\d.]/g, '').replace(/\\.{2,}/g, '.').replace('.', '$#$').replace(/\\./g, '').replace('$#$', '.').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/, '$1$2.$3').replace(/^\\./g, '').replace(/^0+(\\d)/, '$1')";

function normalizeAmount(value) {
    if (value === '' || value === null || typeof value === 'undefined') {
        return null;
    }
    const amount = Number(value);
    return Number.isNaN(amount) ? NaN : amount;
}

function validateJudgmentAmounts(form) {
    const compensationAmount = normalizeAmount(form.compensationAmount);
    const policyAgreedJudgmentAmount = normalizeAmount(form.policyAgreedJudgmentAmount);
    const exceedPolicyAgreedJudgmentAmount = normalizeAmount(form.exceedPolicyAgreedJudgmentAmount);

    if (Number.isNaN(compensationAmount) || Number.isNaN(policyAgreedJudgmentAmount) || Number.isNaN(exceedPolicyAgreedJudgmentAmount)) {
        return { valid: false, message: '金额格式不正确，请按现有金额字段格式录入' };
    }
    if ((policyAgreedJudgmentAmount !== null && policyAgreedJudgmentAmount < 0) || (exceedPolicyAgreedJudgmentAmount !== null && exceedPolicyAgreedJudgmentAmount < 0)) {
        return { valid: false, message: '新增判决金额不能小于0' };
    }
    if (policyAgreedJudgmentAmount === null && exceedPolicyAgreedJudgmentAmount === null) {
        return { valid: true };
    }
    if (compensationAmount === null) {
        return { valid: false, message: '填写判决金额前请先录入我司赔付金额' };
    }
    if ((policyAgreedJudgmentAmount || 0) + (exceedPolicyAgreedJudgmentAmount || 0) > compensationAmount) {
        return { valid: false, message: '保单约定内判决金额和超保单约定判决金额之和不能超过我司赔付金额' };
    }
    return { valid: true };
}

module.exports = {
    AMOUNT_INPUT_ONINPUT,
    normalizeAmount,
    validateJudgmentAmounts
};
